import React, { useEffect, useContext } from 'react'
import { BASE_URL } from '../api/api';
import axios from 'axios';
import { Auth } from '../context/Auth';
import { useCookies } from 'react-cookie';

const HiddenComponent = () => {
    const auth = useContext(Auth)
    const [cookies, setCookie] = useCookies(['token', 'userId', 'isLoggedIn', 'channelId']);
    const [, , removeCookie] = useCookies();

    useEffect(() => {
        if (cookies.isLoggedIn) {
            auth.authReducerDispatch({ type: "updateUserId", payload: { userId: cookies.userId } });
            axios.post(`${BASE_URL}/api/auth/fetch-user-details`, { userId: cookies.userId })
                .then(res => {
                    console.log(res, "fetch User in Hidden Component");
                    if (res.data.statusText === "success") {
                        if (res.data.user.channelId) {
                            auth.authReducerDispatch({ type: "updateChannelId", payload: { channelId: res.data.user.channelId } });

                            // updateUserChannelDetails(res.data.user.channelId);
                            // auth.authReducerDispatch({ type: "updateChannelHandle", payload: { channelhandle: res.data.user.channelHandle } });
                        }
                    }
                })
                .catch(err => console.log(err))
        } else {
            removeCookie('token');
            removeCookie('userId');
            removeCookie('isLoggedIn');
            removeCookie('channelId');
        }
    }, [cookies.isLoggedIn]);

    // function updateUserChannelDetails(channelID) {
    //     const headers = {
    //         'Content-Type': 'application/json',
    //         'Authorization': `${cookies.token}`
    //     };

    //     axios.post(`${BASE_URL}/api/auth/fetch-user-details`, { userId: cookies.userId })
    //         .then(res => {
    //             if (res.data.statusText === "success") {
    //                 if (res.data.user.channelId) {
    //                     fetchChannel(res.data.user.channelId)
    //                 }
    //             }
    //         })

    // function fetchChannel(requestingId) {
    //     axios.post(`${BASE_URL}/api/channels/fetch-channel`, {
    //         channelId: channelID,
    //         requestingUserId: requestingId
    //     }, { headers: headers })
    //         .then(res => {
    //             const data = res.data.channelData;
    //             console.log(res, "Channel Fetched")
    //             auth.authReducerDispatch({ type: "updateChannelHandle", payload: data.channelHandle });
    //             // setchannelDetails({ ...channelDetails, channelName: data.channelName, about: data.about, handle: data.channelHandle, logo: data.logo, followers: data.followers, posts: data.posts })
    //         })
    //         .catch(err => console.log(err, "Error!, Fecthing channel details"))
    // }
    // }

    return (
        <div style={{ display: "none" }}></div>
    )
}

export default HiddenComponent